import { Either } from "core/types/Either";
import { FeatureFlag } from "domain/entity/FeatureFlag";

export abstract class IFeatureFlagRepository {
  abstract getFlag(key: string): Promise<Either<Error, FeatureFlag>>;
}
